import React, { useEffect, useRef, useState } from "react";
import navIcon01 from "../images/nav_icon_01.png";
import navIcon02 from "../images/nav_icon_02.png";
import logo01 from "../images/logo_01.png";
import hamburger01 from "../images/hamberger_01.png";
import sideClose from "../images/side-close.png";
import settingIcon01 from "../images/setting_icon_01.png";
import logoutIcon01 from "../images/logout_icon_01.png";
import { Link, useNavigate } from "react-router-dom";
import { getUserAuthorityName } from "../utils/common";
import { deleteToken, useAppContext } from "../utils/store";
import { apiWrapper } from "../apis/CommonApi";
import * as mainApi from "../apis/MainApi";
import * as accountApi from "../apis/AccountApi";
import useInterval from "../utils/useInterval";

export default function MainHeader({
  isOpenMenu,
  isShowTopPanel,
  isShowNotice,
}) {
  const navigate = useNavigate();
  const {
    store: { userName, userAuthority },
    dispatch,
  } = useAppContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (isShowNotice === true) {
      apiWrapper(async () => {
        const result = await mainApi.getNoticePostList();
        const { status, data } = result;
        if (status === true) {
          setDataSource(data);
        }
      });
    }
  }, []);

  useInterval(() => {
    if (dataSource.length > 0) {
      setCurrentIndex((prevIndex) => {
        return (prevIndex + 1) % dataSource.length;
      });
    }
  }, 5000);

  const handleOpenMenu = () => {
    const sideMenu = document.querySelector("#hamMenu"); // ✅ id로 선택
    sideMenu.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  };

  const handleCloseMenu = () => {
    const sideMenu = document.querySelector("#hamMenu"); // ✅ id로 선택
    sideMenu.classList.remove("open");
    document.documentElement.style.overflow = "";
  };

  const handleLogout = () => {
    if (window.confirm("로그아웃하시겠습니까?")) {
      apiWrapper(async () => {
        const result = await accountApi.logout();
        const { status, data } = result;
        if (status === false) {
          alert("로그아웃에 실패하였습니다.");
        }
      });

      dispatch(deleteToken());
      navigate("/");
    }
  };

  const handleNotice = () => {
    navigate("/notice/");
  }

  return (
    <>
      <div class="mainHeader darkHeader">
        {isOpenMenu === false && (
          <>
            <button class="btn btn-power" />
            <div class="logo-wrap">
              <img src={logo01} alt="Fire-On" />
            </div>
          </>
        )}
        <div class="btn-wrap">
          {/* <Link class="btn btn-alarm" to="/fireSmsLog.html">
                    <img src={navIcon02} alt="alarm" />
                    <div class="alarm-badge"></div>
                </Link> */}
          {isOpenMenu ? (
            <button class="btn btn-close ham-close" onClick={handleCloseMenu}>
              <img src={sideClose} alt="close" />
            </button>
          ) : (
            <button class="btn btn-hamberger" onClick={handleOpenMenu}>
              <img src={hamburger01} alt="menu" />
            </button>
          )}
        </div>
      </div>
      {isShowTopPanel === true && (
        <>
          {isShowNotice === true && (
            <div className={`noticeWrap`} style={{ display: "flex" }} onClick={handleNotice}>
              {dataSource[currentIndex] && (
                <div class="notice-title">
                  {`[공지] ${dataSource[currentIndex].title}`}
                </div>
              )}
            </div>
          )}
          <div class="userWrap">
            <div class="user-info-wrap">
              <p class="user-txt user-title">{userName} 님</p>
              <p class="user-txt user-type">
                {getUserAuthorityName(userAuthority)}
              </p>
              <button class="btn-logout" onClick={handleLogout}>
                <img src={logoutIcon01} alt="로그아웃" />
              </button>
            </div>
            <Link class="btn-setting" to="/user-account/">
              <img src={settingIcon01} alt="설정" />
            </Link>
          </div>
        </>
      )}
    </>
  );
}
